import React from 'react';
import Header from 'modules/header/wholesaler/main';
import Purchase from 'modules/purchase/purchase';
import {useLocation} from 'react-router-dom';

const PurchaseContainer = () => {
  const location = useLocation();
  return (
    <div className="flex w-full h-full flex-col relative">
      <Header
        title={
          location.state && location.state.from === 'buy'
            ? 'ثبت آگهی فروش'
            : 'ثبت آگهی خرید'
        }
      />
      <div className="flex w-full justify-center">
        <div className=" w-[90%] flex flex-col items-center gap-4 h-full py-4 justify-center">
          <Purchase />
        </div>
      </div>
    </div>
  );
};

export default PurchaseContainer;
